import { useState } from "react";

const STEPS = [
  {
    emoji: "🌟",
    title: "Chào mừng đến với\n1% Better Everyday!",
    desc: "Mỗi ngày, bạn nhận 1 thử thách nhỏ — chỉ 2-5 phút — để trở thành phiên bản tốt hơn một chút.",
    visual: ["🧠", "📚", "🏃", "🤝", "🎯", "🎨"],
  },
  {
    emoji: "🎯",
    title: "Cách hoạt động",
    desc: null,
    steps: [
      { icon: "1️⃣", text: "Chọn lĩnh vực bạn muốn cải thiện" },
      { icon: "2️⃣", text: "Nhận thử thách được AI tạo riêng cho bạn" },
      { icon: "3️⃣", text: "Hoàn thành & ghi lại cảm nhận" },
    ],
  },
  {
    emoji: "🔥",
    title: "Giữ Streak, Mở Thành Tích",
    desc: "Hoàn thành mỗi ngày để xây dựng streak. Streak càng dài, thành tích càng nhiều!",
    badges: [
      { emoji: "🔥", label: "3 ngày" },
      { emoji: "💪", label: "7 ngày" },
      { emoji: "⚡", label: "14 ngày" },
      { emoji: "🏅", label: "30 ngày" },
      { emoji: "💎", label: "60 ngày" },
      { emoji: "👑", label: "100 ngày" },
    ],
  },
];

export default function Onboarding({ onComplete }) {
  const [step, setStep] = useState(0);
  const current = STEPS[step];
  const isLast = step === STEPS.length - 1;

  return (
    <div className="onboarding-overlay">
      <div className="onboarding-card">
        {/* Progress dots */}
        <div className="onboarding-dots">
          {STEPS.map((_, i) => (
            <div key={i} className={`onboarding-dot ${i === step ? "active" : i < step ? "done" : ""}`} />
          ))}
        </div>

        {/* Content */}
        <div className="onboarding-emoji">{current.emoji}</div>
        <div className="onboarding-title">{current.title}</div>

        {current.desc && (
          <div className="onboarding-desc">{current.desc}</div>
        )}

        {/* Step 1: category icons */}
        {current.visual && (
          <div className="onboarding-visual-grid">
            {current.visual.map((v, i) => (
              <div key={i} className="onboarding-visual-item" style={{ animationDelay: `${i * 0.1}s` }}>
                {v}
              </div>
            ))}
          </div>
        )}

        {/* Step 2: how it works */}
        {current.steps && (
          <div className="onboarding-steps-list">
            {current.steps.map((s, i) => (
              <div key={i} className="onboarding-step-item" style={{ animationDelay: `${i * 0.15}s` }}>
                <span className="onboarding-step-icon">{s.icon}</span>
                <span className="onboarding-step-text">{s.text}</span>
              </div>
            ))}
          </div>
        )}

        {/* Step 3: badges preview */}
        {current.badges && (
          <div className="onboarding-badges-grid">
            {current.badges.map((b, i) => (
              <div key={i} className="onboarding-badge-item" style={{ animationDelay: `${i * 0.08}s` }}>
                <span style={{ fontSize: "24px" }}>{b.emoji}</span>
                <span style={{ fontSize: "10px", color: "var(--text-muted)" }}>{b.label}</span>
              </div>
            ))}
          </div>
        )}

        {/* Actions */}
        <div className="onboarding-actions">
          {step > 0 && (
            <button className="onboarding-btn-back" onClick={() => setStep(s => s - 1)}>
              Quay lại
            </button>
          )}
          <button className="onboarding-btn-next" onClick={() => isLast ? onComplete() : setStep(s => s + 1)}>
            {isLast ? "Bắt Đầu Ngay! 🚀" : "Tiếp theo →"}
          </button>
        </div>

        {!isLast && (
          <button className="onboarding-skip" onClick={onComplete}>
            Bỏ qua
          </button>
        )}
      </div>
    </div>
  );
}
